import { isEmptyValue } from "../helper/isEmptyValue";
import type { SyncValidationRule } from "../types/validation";

export function minItems<TValue>(
  min: number,
): SyncValidationRule<readonly TValue[] | null | undefined> {
  return {
    name: "minItems",
    kind: "sync",
    dependencies: [min],
    validate(value) {
      if (isEmptyValue(value)) {
        return undefined;
      }
      return Array.isArray(value) && value.length >= min
        ? undefined
        : { messageKey: "validation.minItems", params: { min } };
    },
  };
}

export function maxItems<TValue>(
  max: number,
): SyncValidationRule<readonly TValue[] | null | undefined> {
  return {
    name: "maxItems",
    kind: "sync",
    dependencies: [max],
    validate(value) {
      if (isEmptyValue(value)) {
        return undefined;
      }
      return Array.isArray(value) && value.length <= max
        ? undefined
        : { messageKey: "validation.maxItems", params: { max } };
    },
  };
}

export function oneOf<TValue>(values: readonly TValue[]): SyncValidationRule<TValue> {
  return {
    name: "oneOf",
    kind: "sync",
    dependencies: [values],
    validate(value) {
      return values.includes(value) ? undefined : { messageKey: "validation.oneOf" };
    },
  };
}

export function notOneOf<TValue>(values: readonly TValue[]): SyncValidationRule<TValue> {
  return {
    name: "notOneOf",
    kind: "sync",
    dependencies: [values],
    validate(value) {
      return values.includes(value) ? { messageKey: "validation.notOneOf" } : undefined;
    },
  };
}
